import { Component } from '@angular/core';

@Component({
  selector: 'app-veener-loader-btn',
  templateUrl: './veener-loader-btn.component.html',
  styleUrls: ['./veener-loader-btn.component.scss']
})
export class VeenerLoaderBtnComponent {

}
